var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.on)?_c('div',{ref:"modalBubbleHint",staticClass:"hint_bubble",style:({
    marginTop: _vm.modalY - _vm.height - 10 + 'px',
    marginLeft: _vm.modalX - _vm.width/2 + 'px'
  })},[_c('div',[_vm._v(_vm._s(_vm.msg))]),_c('div')]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }